export default __webpack_public_path__ + "static/incredible-web-42d0a0e632b570b5bb4a6e7390bee27c.webp";